var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubject = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 3.082c-.851-.63-2.076-1.673-5.178-1.922-.786-.063-1.427.586-1.427 1.375v6.14c0 .79.64 1.42 1.427 1.483C7.924 10.406 9.15 11.45 10 12.08V3.082ZM10 3.082c.851-.63 2.076-1.673 5.178-1.922.786-.063 1.427.586 1.427 1.375v6.14c0 .79-.64 1.42-1.427 1.483-3.102.248-4.327 1.292-5.178 1.922V3.082ZM13.064 14.488v3.495",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m4.743 18.393-1.886-1.964 1.886-1.965L15 14.317a2.112 2.112 0 1 1 0 4.224l-10.257-.148Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
export default SvgSubject;